import { render, staticRenderFns } from "./BsDivider.vue?vue&type=template&id=3f6188c1&"
import script from "./BsDivider.vue?vue&type=script&lang=js&"
export * from "./BsDivider.vue?vue&type=script&lang=js&"
import style0 from "./BsDivider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports